import { render, staticRenderFns } from "./FieldImageLabel.vue?vue&type=template&id=1b405db4&"
import script from "./FieldImageLabel.vue?vue&type=script&setup=true&lang=js&"
export * from "./FieldImageLabel.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports